import type { RouteConfig, RoutesBuilder } from "@kestrel/router";

export type { RouteConfig };

/**
 *
 *
 *
 */
export function defineRoute(route: RouteConfig): RouteConfig {
  return route;
}

/**
 *
 *
 */
export function defineRoutes(): RoutesBuilder<[]> {
  const routes = [] as RouteConfig[];

  const builder = {
    add(route: RouteConfig) {
      routes.push(route);
      return builder;
    },
    build: () => routes,
  };
  return builder as never;
}
